<script>
import StaticProcessor from '@lib/processors/static-processor'
import { TABLE_COLUMNS, ROLE_COLUMN, PROVIDER_ID_COLUMN } from './products.table'

export default {
  name: 'ProductsTable',
  props: {
    title: {
      type: Boolean,
      default: true,
    },
    products: {
      type: Array,
      default: () => [],
    },
    roles: {
      type: Array,
      default: null,
    },
    showProviderId: {
      type: Boolean,
      default: false,
    },
    provider: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      processor: null,
    }
  },
  computed: {
    columns() {
      const columns = TABLE_COLUMNS.slice()

      if (this.roles) {
        columns.push(ROLE_COLUMN)
      }

      if (this.showProviderId) {
        columns.push(PROVIDER_ID_COLUMN)
      }

      return columns
    },
    tableData() {
      return this.products.map(item => {
        return {
          ...item,
          roles: (this.roles || []).filter(i => {
            return i.productId === item.product.id
          }),
          externalProvider: (this.provider.externalProviders || []).find(i => {
            return i.productId === item.product.id
          }),
        }
      })
    },
  },
  created() {
    this.processor = new StaticProcessor({
      component: this,
      data: this.tableData,
      disableQueryString: true,
    })
  },
}
</script>

<template>
  <div :class="$style.products">
    <div
      v-if="title"
      :class="$style.title"
    >
      Products
    </div>
    <table-layout
      v-if="processor"
      :class="$style.table"
      shadow="never"
      table-name="products-table"
      :processor="processor"
      :columns="columns"
      :fragments="false"
      :hider="false"
      :table-controls="false"
    />
  </div>
</template>

<style lang="scss" module>
.products {
  padding: 0;
  margin: 0;
}

.title {
  font-size: rem(22px);
  font-weight: 600;
}

.table {
  border: none !important;
  box-shadow: none !important;

  :global {
    .el-card__body > div {
      padding: 0;
    }
  }
}
</style>
